export default __webpack_public_path__ + "static/silkserif-extralight-77128673aea9f1c5d73e60f580c5175c.woff2";